module.exports = __webpack_public_path__ + "static/media/A (12).5184a175.jpg";